<template>
    <div v-if="showMap" class="map" :id="initId">
      <div class="loction center">
          x：{{longitude_x}}y：{{longitude_y}}
      </div>
      <div v-if="false" class="change-map" @mouseover="showMore=true" @mouseout="showMore=false" :style="{'max-height':(showMore?'91px':'43px')}">
        <div class="yx" v-for="i in mapStyles" :key="i.index" @click="showWhere(i)">
          <img :src="i.url" alt="">
        </div>
      </div>
      <div class="change-map" @mouseover="showMore=true" @mouseout="showMore=false">
        <div class="map-box" v-show="showMore">
          <p class="p1">选择底图</p>
          <hr>
          <div class="b-box centerS">
            <div class="base-site center2" @click="showWhere(i)" :class="i.isAc?'map-ac':'map-d-ac'" v-for="i in mapStyles" :key="i.index">
              <img :src="i.img" alt="">
              <p>{{i.name}}</p>
            </div>
          </div>
        </div>
        <div class="parent center">
          <img src="@/assets/image/earth.png" alt="">
        </div>
      </div>
    </div>
</template>

<script>
var viewer
const Cesium = window.Cesium
let labelImagerySL,labelImagery,labelImageryGoogle
import Cesium_measure from "@/utils/CesiumMeasure"
export default {
    props:{
        productUnit:{
            type:String
        },
        dataQuery:{
            type:Object
        },
        timeResolutionUnit:{
            type:String
        },
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Object
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
            type: String
        },
        collections: {
            type: Array
        },
        legendObj:{
            type:Object
        },
        simpleName:{
            type:String
        },
        coordinates:{
            type:String
        }
    },
    components:{
    },
    data(){
        return{
          yxLayer:null,
          slLayer:null,
          ggLayer:null,
          mapStyles:[
            {img: require('../../../assets/image/yx.png'),type:'yx', isAc: true,name:"天地图(影像)",index:0},
            {img: require('../../../assets/image/sl.png'),type:'sl', isAc: false,name:"天地图(矢量)",index:1},
            {img: require('../../../assets/image/yx.png'),type:'go', isAc: false,name:"谷歌(影像)",index:2},
          ],
          showMore:false,
          CesiumMeasure:null,
          startTime:'',
          endTime:'',
          nowTime:'',
          showTime:null,
          AllCollection:[],
          layerIndex: 0,
          isFirst:true,
          loading:false,
          initWind:false,
          showWind:false,
          handlerMarker:null,
          tableList:[],
          longitude_x:'',
          longitude_y:'',
          labelImagerySL:null,
          labelImagery:null,
          computedObj : {
            max: {},
            min: {},
            ave: '',
            sta: ''
          },
          showMap: true
        }
    },
    watch:{
    },
    beforeDestroy () {
      let gl = viewer.scene.context._originalGLContext
      viewer.destroy()
      gl.getExtension("WEBGL_lose_context").loseContext();
      gl=null
      viewer=null
    },
    methods:{
        cartesianTolngLatAlt(cartesian){
          
            const cartographic = Cesium.Cartographic.fromCartesian(cartesian)
            const longitude = Cesium.Math.toDegrees(cartographic.longitude)
            const latitude = Cesium.Math.toDegrees(cartographic.latitude)
            this.$emit('searchHistoryData',longitude,latitude)
        },
        drawMarker () {
          this.CesiumMeasure.clearAll()
          this.handlerMarker.activate()
        },
        cancelDraw () {
          this.CesiumMeasure.clearAll()
          this.handlerMarker.clear()
          this.handlerMarker.deactivate()
        },
        showWhere(val){
          this.mapStyles.forEach(element => {
            element.isAc = false
          });
          val.isAc = true
          switch (val.type) {
            case 'yx':
              viewer.imageryLayers.remove(this.slLayer);
              viewer.imageryLayers.remove(this.ggLayer);
              this.yxLayer = viewer.imageryLayers.addImageryProvider(labelImagery);
              break;
            case 'go':
              viewer.imageryLayers.remove(this.yxLayer);
              viewer.imageryLayers.remove(this.ggLayer);
              this.slLayer = viewer.imageryLayers.addImageryProvider(labelImageryGoogle);
              break;
            default:
              viewer.imageryLayers.remove(this.yxLayer);
              viewer.imageryLayers.remove(this.slLayer);
              this.ggLayer = viewer.imageryLayers.addImageryProvider(labelImagerySL);
              break;
          }
        },
        ceju(){
          this.CesiumMeasure.ceju()
        },
        cemian(){
          this.CesiumMeasure.cemian()
        },
        getLIST(){
          let scene = viewer.scene
          const s3mUrl = this.iserverHeader+this.url
          scene.open(s3mUrl)
        },
        initMap(){
            let that = this
            Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
            viewer = new Cesium.Viewer(this.initId,{
                animation: false, //创建动画部件
                shouldAnimate : true,
                orderIndependentTranslucency: false,
                contextOptions: {
                  webgl: { alpha: true},
                  requestWebgl2: true
                },
              navigation: false,
              enableLighting: true,
            });
            //数据查询init
            this.handlerMarker = new Cesium.DrawHandler(viewer,Cesium.DrawMode.Marker)
            this.handlerMarker.drawEvt.addEventListener((result) =>{
              console.log({
                x: result.object.position.x,
                y: result.object.position.y,
                z: result.object.position.z,
              });
              this.cartesianTolngLatAlt(result.object.position);
            })
            // viewer.scene.globe.depthTestAgainstTerrain = false;//关闭深度检测
            //init结束
            //去掉超图supermap
            viewer._cesiumWidget._creditContainer.style.display = "none";
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
            
            viewer.scene.globe.enableLighting = true


            viewer.scene.sun.show = false
            viewer.scene.moon.show = false
            viewer.scene.skyBox.show = false

            viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)

            viewer.imageryLayers.removeAll()
            labelImagery = new Cesium.TiandituImageryProvider({
              mapStyle : Cesium.TiandituMapsStyle.IMG_C, //天地图全球中文注记服务（经纬度投影）
              token: '859e010cf86575ec92544de21ad4472e',
            });
            labelImagerySL = new Cesium.TiandituImageryProvider({
              mapStyle : Cesium.TiandituMapsStyle.VEC_C, //天地图全球中文注记服务（经纬度投影）
              token: '859e010cf86575ec92544de21ad4472e',
            });
            labelImageryGoogle = new Cesium.UrlTemplateImageryProvider({
              url: "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&gl=CN&x={x}&y={y}&z={z}"
            });
            // let sl = viewer.imageryLayers.addImageryProvider(labelImagerySL);
            this.yxLayer = viewer.imageryLayers.addImageryProvider(labelImagery);
            // yx.typename='yx'
            // sl.typename='sl'

            var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
            var scene = viewer.scene
            var ellipsoid = scene.globe.ellipsoid
            handler.setInputAction(function(movement){
                let click_position =  viewer.scene.camera.pickEllipsoid(movement.endPosition,ellipsoid);
                let carto_position = ellipsoid.cartesianToCartographic(click_position);
                that.longitude_x = Cesium.Math.toDegrees(carto_position.longitude);
                that.longitude_y = Cesium.Math.toDegrees(carto_position.latitude);
                that.longitude_x = that.longitude_x.toFixed(6)
                that.longitude_y = that.longitude_y.toFixed(6)
            },Cesium.ScreenSpaceEventType.MOUSE_MOVE);

            this.CesiumMeasure = new Cesium_measure(viewer)
            this.CesiumMeasure.initCemian()
            this.CesiumMeasure.initCeJu()
              try {
                that.getLIST()
              } catch (error) {
                  console.log(error);
              }
        },
        
    },
    created(){
    },
    destroyed(){
    },
    mounted(){
      this.initMap()
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
    .loction{
        position: absolute;
        left: 12px;
        top: 0px;
        z-index: 100000;
        color: white;
        height: 29px;
        padding: 0 12px;
        background-image: url("../../../assets/image/product-detail-dialog/矩形 3 拷贝.png");
        background-size: 100% 100%;
    }
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 0px;
        padding-left: 12px;
        z-index: 100000;
        .unit{
            color: white;
        }
        .right{
            position: absolute;
            left: 36px;
            bottom: 6px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 160px;
            p{
              font-size: 12px;
                width: 47px;
                display: inline;
                color: white;
            }
        }
        .legend-show{
            width: 24px;
            height: 160px;
        }
    }
    .time-step{
      position: absolute;
      left: 211px;
      bottom: 10px;
      z-index: 60;
    }
}
.change-map{
  position: absolute;
  right: 8px;
  // transform: translate(calc(50% + 200px), -20px);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  .parent{
    width: 46px;
    height: 46px;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    margin-left: 12px;
  }
  .map-box{
    width: auto;
    height: 130px;
    background: #FFFFFF;
    border-radius: 10px;
    .p1{
      color: black;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
    }
    hr{
      margin: 4px 0;
      width: 206px;
    }
  }
  .b-box{
    font-size: 12px;
    padding: 0 8px;
    .base-site{
      cursor: pointer;
    }
    img{
      width: 80px;
      height: 60px;
      border-radius: 4px;
    }
    .map-ac{
      img{
        border: 4px solid #3390F8;
      }
      color: #3390F8;
    }
    .map-d-ac{
      img{
        border: 4px solid white;
      }
      color: black;
    }
  }
}
</style>
